module.exports = __webpack_public_path__ + "static/denny-c67973e55b73d1a8d1e4a63189edd3c4.png";